import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // A 50-100ms delay is the "sweet spot" to ensure Turbo
    // has finished swapping the DOM elements.
    setTimeout(() => {
      this.element.focus()
    }, 75)
  }
}
